import type { MotionPlayer } from './player';

const players = new Map<string, MotionPlayer>();

export function registerPlayer(frameId: string, p: MotionPlayer): void {
  players.set(frameId, p);
}

export function unregisterPlayer(frameId: string): void {
  players.delete(frameId);
}

export function getPlayer(frameId: string): MotionPlayer | undefined {
  return players.get(frameId);
}
